import { AvailabilityRequestType } from "@app/availability/constants/AvailabilityRequestType";
import { constructObjectBySearchParams } from "@app/common/utils/searchQueryUtils";

/**
 * Helper to validate availability search params.
 * Doesn't match server side validation 1 on 1 but sufficient for client side
 * mainly to determine whether state is valid to go into checkout flow
 * @param searchParams
 * @returns
 */

export const isAvailabilitySearchParamsValidForRequestType = (searchParams: URLSearchParams): boolean => {
    const requestType = searchParams.get("rt") ? (Number(searchParams.get("rt")) as AvailabilityRequestType) : undefined;

    const hasValue = (value: any) => value !== undefined && value !== "undefined";

    let isValid = true;

    // has valid request type
    isValid = isValid && Object.values(AvailabilityRequestType).includes(requestType || "");

    // has valid from and to date
    isValid = isValid && hasValue(searchParams.get("ci")) && hasValue(searchParams.get("co"));

    // promo code (pc) is optional
    // corp code (cc) is optional
    if (requestType && [AvailabilityRequestType.Check, AvailabilityRequestType.Get].includes(requestType)) {
        const searchParamsObject = constructObjectBySearchParams(searchParams);

        // should have language (lg) and currency (cu)
        isValid = isValid && hasValue(searchParams.get("lg")) && hasValue(searchParams.get("cu"));

        const bookings = searchParamsObject?.rs || [];

        // should have at least one booking
        isValid = isValid && bookings.length > 0;

        if (bookings.length) {
            // should have at least one booking with room and rate
            isValid =
                isValid &&
                !bookings.some((booking: any) => {
                    // return true if found incomplete booking
                    // booking should have adults count
                    const hasAdultsCount = hasValue(booking?.ac) && hasValue(booking?.ro);

                    // a booking should have rate id and room id
                    const hasRoomAndRate = hasValue(booking?.ra) && hasValue(booking?.ro);

                    return !hasAdultsCount || !hasRoomAndRate;
                });
        }
    }

    return isValid;
};
